import { useCallback, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  getReqDutyInfo,
  getReqStaffInfo,
  getRequestAmount,
} from "../../../redux/actions";
import "./RequestComponent.less";
import StaffSelectionTable from "./StaffSelectionTable";
import ApprovalTable from "./ApprovalTable";

function RequestComponent(props) {
  const {
    fetchReqStaffInfo,
    fetchReqDutyInfo,
    isApprover,
    clearDutyInfo,
    fetchRequestAmount,
    req_duty_info,
    req_staff_info,
  } = props;
  //Component step info
  const [step, setStep] = useState(-1);

  const setToStep = useCallback(
    (level) => {
      if (level === 0) {
        //Set level to 0 => reset dtl data
        setStep(level);
        clearDutyInfo();
      } else if (level === -1) {
        setStep(level);
        //FETCH new numbers
        fetchRequestAmount();
      } else {
        setStep(level);
      }
    },
    [clearDutyInfo, fetchRequestAmount]
  );

  //Set Approval inital state
  useEffect(() => {
    if (step === -1) {
      fetchReqStaffInfo(isApprover);
      setToStep(0);
    }
  }, [fetchReqStaffInfo, isApprover, step, setToStep]);

  const onRowClick = (record, rowIndex) => {
    fetchReqDutyInfo(record.STAFF_NO, record, isApprover);
    setToStep(1);
  };

  return (
    <div style={{ padding: "1rem 0" }}>
      {step === 0 && (
        <StaffSelectionTable
          req_staff_info={req_staff_info}
          onRowClick={onRowClick}
        />
      )}
      {step === 1 && (
        <ApprovalTable
          req_duty_info={req_duty_info}
          isApprover={isApprover}
          setToStep={setToStep}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    req_staff_info: state.data.req_staff_info,
    req_duty_info: state.data.req_duty_info,
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchReqStaffInfo: (isApprover) => {
    return dispatch(getReqStaffInfo(isApprover));
  },
  fetchReqDutyInfo: (staffNo, staffInfo, isApprover) => {
    return dispatch(getReqDutyInfo(staffNo, staffInfo, isApprover));
  },
  clearDutyInfo: () => {
    return dispatch({ type: "CLEAR-DUTY-INFO" });
  },
  fetchRequestAmount: () => {
    dispatch(getRequestAmount());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(RequestComponent);
